<style src="./view.scss" lang="scss"></style>
<template src="./view.html"></template>

<script>
import { forEachTree } from '@/common/utils'
import projectdetial from '../qdffprojectdetial.vue'

export default {
    name: 'projectdetialWrap',
    components: { projectdetial },
    data() {
        return {
            info: {},
            dealType: { 1: '买断', 2: '分成' }
        };
    },
    methods: {
        init() {
            this.photoworkReviewInfo()
        },
        operationSuccess() {
            this.$router.back()
        },
        async photoworkReviewInfo() {
            let {id ,type} = this.$route.query
            let data = await this.api.photoworkReviewInfo({type, id })

            this.info = Object.assign(data.fileInfo, data.checkInfo, data.projectInfo)
        },
    },
    activated() {
        this.init()
    },
    created() {
        this.init()
    },
    computed: {
        currentOperationAccess() {
            let currentAccess = []
            
            forEachTree(window.$menuAccess.top_banner || [], (item) => {
                // 项目验收权限点 16
                if(+item.id === 16) {
                    let access = item.child.find(item => +item.business_type === +this.info.businessType)
                    if(access) {
                        currentAccess =  access.child
                    }
                }
            }, 'child')

            return currentAccess.map(item => item.id)
        }
    }
};
</script>
